<script setup lang="ts">
import { Ref, ref, watch } from 'vue'
import GbButton from '@/components/GbButton.vue'
import GbDialog from '@/components/GbDialog.vue'

const props = defineProps({
  externalOpen: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:externalOpen'])

const visibleRef: Ref<boolean> = ref(props.externalOpen)

const closeModal = function (): void {
  visibleRef.value = false
  emit('update:externalOpen', false)
}

watch(
  () => props.externalOpen,
  () => {
    visibleRef.value = props.externalOpen
  }
)

watch(
  () => visibleRef.value,
  () => {
    emit('update:externalOpen', visibleRef.value)
  }
)
</script>
<template>
  <GbDialog
    dialogId="unarchive-first-modal"
    v-model:visible="visibleRef"
    header="Unarchive First"
    :footer-buttons="true"
  >
    <template #bodyContent>
      <div class="flex flex-col gap-2 text-gray-700">
        <p>To open this folder, unarchive it first.</p>
      </div>
    </template>
    <template #footerButtonRight>
      <GbButton type="button" gbTheme="bluePrimary" label="OK" @click="closeModal"></GbButton>
    </template>
  </GbDialog>
</template>
